import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as spaceFunctions from '../../space-functions'

export const RESOURCE = {
  payload: {
    description:
      'A classification of space based on its primary function, such as research, instruction, or administration used in indirect rate proposal.',
    dimension: spaceFunctions.RESOURCE.payload,
    level: 0,
    name: 'Functional Usage',
    partialId: PartialId.Standard.create('func'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
